import React from 'react';
import TextField from '@material-ui/core/TextField';

function MyLabels(props) {

	let handleChange = (event) => {
		let id = event.target.id.split('_')[0];
		props.onChangeLabel(id, event.target.value);
	}

	return (
		<div align="center" style={{ paddingTop: 30, display: 'flex', flexDirection: 'column' }}>
			<TextField id="title_text" defaultValue={props.title}
				onChange={handleChange} style={{ margin: 15 }}
				placeholder="Title"
			/>
			<TextField id="subtitle_text" defaultValue={props.subtitle}
				onChange={handleChange} style={{ margin: 15 }}
				placeholder="SubTitle"
			/>
			<TextField id="athlete_text" defaultValue={props.athlete}
				onChange={handleChange} style={{ margin: 15 }}
				placeholder="Athelet's name"
			/>
			<TextField id="distance_text" defaultValue={props.distance}
				onChange={handleChange} style={{ margin: 15 }}
				placeholder="Distance"
			/>
			<TextField id="time_text" defaultValue={props.time}
				onChange={handleChange} style={{ margin: 15 }}
				placeholder="Time"
			/></div>
	)

}

export default MyLabels;


// WEBPACK FOOTER //
// ./src/components/MyLabels.js